<template>
  <section class="home_news">
    <div class="home_news_inner">
      <!-- 头部 -->
      <div class="home_news_header">
        <div class="home_news_title_wrap">
          <span class="home_news_title">资讯信息</span>
          <span class="home_news_title_en">INFORMATION</span>
        </div>
        <span class="more_text" @click="toNewsList">查看更多&gt;</span>
      </div>

      <!-- 内容区 -->
      <div class="home_news_body" v-if="newsList.length > 0">
        <!-- 左侧大图 -->
        <div
          class="home_news_main"
          @click="
            linkJump('/info/detail', { type: 'news', id: newsList[0].id })
          "
        >
          <div class="main_img_wrap">
            <img :src="newsList[0].bgUrl" alt="" />
          </div>
          <div class="main_content">
            <div class="main_title">{{ newsList[0].newsTitle }}</div>
          </div>
          <div class="main_icon">
            <div class="main_date">{{ newsList[0].publishDate }}</div>
            <img src="@/assets/img/informationIco.png" alt="" />
          </div>
        </div>

        <!-- 右侧列表 -->
        <div class="home_news_list">
          <div
            v-for="(item, index) in newsList.slice(1, 4)"
            :key="index"
            class="news_item"
            @click="linkJump('/info/detail', { type: 'news', id: item.id })"
          >
            <img :src="item.bgUrl" alt="" />
            <div class="item_content">
              <div class="item_title">{{ item.newsTitle }}</div>
              <div class="item_arrow">
                <div class="item_date">{{ item.publishDate }}</div>
                <img
                  class="icon_default"
                  src="@/assets/img/informationIco.png"
                  alt=""
                />
                <img
                  class="icon_active"
                  src="@/assets/img/activeInformationIco.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 无数据 -->
      <div class="home_news_empty" v-else>暂无数据</div>
    </div>
  </section>
</template>

<script>
import { newsListApi } from "@/api/banner";

export default {
  name: "HomeNews",
  data() {
    return {
      newsList: [],
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    async getNewsList() {
      const res = await newsListApi();
      if (res.code == 1) {
        this.newsList = res.data || [];
      } else {
        this.$message.error(res.message);
      }
    },
    toNewsList() {
      this.$router.push({
        path: "/info",
        query: { type: "news" },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/static/styles/variables.less";

.home_news {
  width: 100%;
  background: #ffffff;
}

.home_news_inner {
  width: @defaultWidth;
  margin: 0 auto;
  padding: 40px 0 60px;
}

.home_news_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.home_news_title_wrap {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.more_text {
  font-size: 14px;
  color: #3b75dd;
  cursor: pointer;
}

.more_text:hover {
  opacity: 0.8;
}

.home_news_body {
  display: flex;
  gap: 30px;
}

.home_news_empty {
  text-align: center;
  padding: 100px 0;
  color: #999;
  font-size: 14px;
}

// 左侧大图
.home_news_main {
  overflow: hidden;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
}

.main_img_wrap img {
  width: 705px;
  height: 410px;
  border-radius: 6px;
}

.main_content {
  width: 705px;
  padding: 24px 0 37px 0;
}

.main_title {
  font-size: 18px;
  font-weight: 500;
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.main_date {
  font-size: 14px;
  color: #999;
}

.main_icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.main_icon img {
  width: 23px;
  height: 23px;
}

// 右侧列表
.home_news_list {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.news_item {
  background: #fff;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  gap: 24px;
}

.news_item > img {
  width: 164px;
  height: 164px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
}

.item_content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 15px 0;
}

.item_title {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  line-height: normal;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.item_arrow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item_date {
  font-size: 14px;
  color: #999;
}

.icon_default {
  width: 23px;
  height: 23px;
  display: block;
}

.icon_active {
  width: 23px;
  height: 23px;
  display: none;
}

// hover 效果
.news_item:hover .item_title,
.news_item:hover .item_date {
  color: #3b75dd;
}

.news_item:hover .icon_default {
  display: none;
}

.news_item:hover .icon_active {
  display: block;
}
</style>
